import { getSticker } from "../core/stickers";
import { MessageData } from "../core/types";

interface Props {
  message: MessageData;
}

export default function Message({ message }: Props) {
  const isMe = message.sender === "me";
  const time = new Date(message.timestamp).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <div style={{ display: "flex", justifyContent: isMe ? "flex-end" : "flex-start" }}>
      <div
        style={{
          background: message.type === "sticker" ? "transparent" : isMe ? "#dcf8c6" : "#ffffff",
          borderRadius: 8,
          padding: message.type === "sticker" ? 0 : "6px 12px",
          maxWidth: "70%",
        }}
      >
        {message.type === "sticker" && message.sticker !== undefined ? (
          <img
            src={getSticker(message.sticker).path}
            alt="sticker"
            style={{ width: 120, height: 120, objectFit: "contain" }}
          />
        ) : (
          <div>{message.text}</div>
        )}
        <div style={{ fontSize: 11, color: "#999", textAlign: "right", marginTop: 2 }}>
          {time}
        </div>
      </div>
    </div>
  );
}
